import dayjs from 'dayjs';

export function getDateRangeForTab(tabKey) {
  const today = dayjs();
  if (tabKey === 'today') {
    return {
      dateStart: today.startOf('day').toDate(),
      dateEnd: today.endOf('day').toDate(),
    };
  }
  if (tabKey === 'backlog') {
    return {
      dateStart: undefined,
      dateEnd: today.subtract(1, 'day').endOf('day').toDate(),
    };
  }
  if (tabKey === 'hold' || tabKey === 'history') {
    return { dateStart: undefined, dateEnd: undefined };
  }
  return {
    dateStart: today.add(1, 'day').startOf('day').toDate(),
    dateEnd: undefined,
  };
}

// รวม logic การกรองต่อแท็บไว้จุดเดียว (เดิมอยู่ใน fetchRows อย่างเดียว) ให้ fetchTabCounts (นับจำนวนของ
// ทุกแท็บพร้อมกันสำหรับโชว์ตัวเลขบนแท็บ) เรียกใช้ตัวเดียวกันได้ กันไม่ให้ตัวเลขบนแท็บกับข้อมูลจริงที่โหลด
// ไม่ตรงกันเพราะ logic แยกกันคนละจุด
//
// ชื่อ query param ของ flag หลัก + ค่าของแท็บ อนาคต/ประวัติ มาจาก mode (constants/modes.js):
// paymentApprovalStatuses (หน้าอนุมัติจ่ายเงิน) / reviewStatuses (หน้าตรวจสอบรายการเบิก)
//
// statuses='PENDING,APPROVE,PREPARE' ของแท็บ backlog/future/hold ใช้กับทั้ง 2 หน้า — หน้าตรวจสอบเคยไม่กรอง
// statuses เลย แต่รายการเก่าทั้งระบบ (สร้างก่อนมีฟีเจอร์ตรวจสอบ) review_status เป็น PENDING/null หมด แท็บ
// "ค้าง" เลยกวาดได้เกือบทั้ง collection (4,485/4,509 แถว) เกือบชน MongoDB BSON 16MB limit — แท็บ "วันนี้"
// ไม่ติดปัญหานี้เพราะมี dateStart/dateEnd บีบไว้แค่วันเดียวอยู่แล้ว เลยปลดล็อก statuses ให้เห็นทุก status
export function getTabQueryParams(mode, tabKey, subTab = 'approved') {
  const { dateStart, dateEnd } = getDateRangeForTab(tabKey);
  const { queryParam } = mode;

  // แท็บ "วันนี้" มี sub-tabs 3 อัน (mirror sub-tab ของ ExpensesTabToday.js) — เกณฑ์คนละแบบกัน
  if (tabKey === 'today') {
    // ด่วน — รายการที่ติดธง is_urgent (urgentQueue): ยังไม่จบเอาหมด + SUCCESS เฉพาะที่จ่ายจริงวันนี้
    // (logic status อยู่ที่ backend pipeline urgentQueue ไม่ต้องกรองเพิ่ม)
    if (subTab === 'urgent') {
      const today = dayjs();
      return {
        statuses: '',
        [queryParam]: '',
        dateStart: undefined,
        dateEnd: undefined,
        urgentQueue: 'true',
        urgentSuccessStart: today.startOf('day').toDate(),
        urgentSuccessEnd: today.endOf('day').toDate(),
      };
    }
    // จ่ายเงินวันนี้ — อนุมัติ (จุดที่ช้าสุด) เมื่อวาน → ครบกำหนดจ่ายวันนี้ (ไม่กรอง Expense.date)
    if (subTab === 'due') {
      const y = dayjs().subtract(1, 'day');
      return {
        statuses: 'APPROVE,PREPARE,SUCCESS',
        [queryParam]: '',
        dateStart: undefined,
        dateEnd: undefined,
        readyDateStart: y.startOf('day').toDate(),
        readyDateEnd: y.endOf('day').toDate(),
      };
    }
    // อนุมัติวันนี้ (default) — พฤติกรรมเดิมของแท็บวันนี้: Expense.date = วันนี้, ทุกสถานะ
    return { statuses: '', [queryParam]: '', dateStart, dateEnd };
  }

  let statuses = 'PENDING,APPROVE,PREPARE';
  let queueStatuses = 'PENDING';
  if (tabKey === 'future') {
    queueStatuses = mode.futureStatuses;
  } else if (tabKey === 'hold') {
    queueStatuses = 'HOLD';
  } else if (tabKey === 'history') {
    statuses = '';
    queueStatuses = mode.historyStatuses;
  }
  return { statuses, [queryParam]: queueStatuses, dateStart, dateEnd };
}
